// extracted by mini-css-extract-plugin
module.exports = {"rgpdMenu":"FSK0h","rgpdText":"_3xnLk","text":"_2KlGJ","rgpdProviderList":"_2HOOj","knowMore":"_1rx4t","save":"qFJF8","button":"LHAqV"};